<template>
  <el-container>
    <fhead></fhead>
    <el-main>
      <el-breadcrumb class="center" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">{{$t('l.home')}}</el-breadcrumb-item>
        <el-breadcrumb-item>Transaction</el-breadcrumb-item>
      </el-breadcrumb>
      <el-card v-loading="loading" class="box-card center" style="margin-top: 16px">
        <div slot="header" class="clearfix">
          <span>{{model.transaction}}</span>
        </div>

        <el-form size="mini" label-width="140px">
          <el-form-item :label="$t('l.transaction.height')">
            <router-link :to="'/block/'+model.height">
              <el-button style="font-size: 14px" type="text">{{model.height}}</el-button>
            </router-link>
          </el-form-item>
          <el-form-item :label="$t('l.transaction.block')">{{model.block}}</el-form-item>
          <el-form-item :label="$t('l.transaction.senderRS')">
            <router-link :to="'/account/'+model.senderRS">
              <el-button style="font-size: 14px" type="text">{{model.senderRS}}</el-button>
            </router-link>
          </el-form-item>
          <el-form-item :label="$t('l.transaction.amountNQT')">{{$g.wallet.amount(model.amountNQT)}}</el-form-item>
          <el-form-item :label="$t('l.transaction.feeNQT')">{{$g.wallet.amount(model.feeNQT)}}</el-form-item>
          <el-form-item :label="$t('l.transaction.recipientRS')">
            <router-link :to="'/account/'+model.recipientRS">
              <el-button style="font-size: 14px" type="text">{{model.recipientRS}}</el-button>
            </router-link>
          </el-form-item>
          <el-form-item
           :label="$t('l.transaction.timestamp')"
          >{{$g.wallet.formatDateTime(model.timestamp,($store.state.epochBeginning-500))}}</el-form-item>
          <el-form-item :label="$t('l.transaction.confirmations')">{{model.confirmations}}</el-form-item>
          <el-form-item :label="$t('l.transaction.attachment')">{{model.attachment}}</el-form-item>
        </el-form>
      </el-card>
    </el-main>
    <el-footer class="footer">
      COPYRIGHT © 2018. ALL RIGHTS RESERVED. DESIGNED BY
      <a
        target="_blank"
        href="https://hebeblock.com/"
      >HEBEBLOCK</a>
    </el-footer>
  </el-container>
</template>


<script>
import fhead from "../fhead.vue";
export default {
  name: "transaction",
  components: {
    fhead
  },
  data() {
    return {
      loading: true,
      model: {}
    };
  },
  methods: {},
  created: function() {
    this.$ajax({
      method: "get",
      url:
        "requestType=getTransaction&transaction=" +
        this.$route.params.transaction
    }).then(response => {
      this.model = response;
      this.loading = false;
    });
  },
  beforeDestroy: function() {}
};
</script>


<style scoped>
</style>  


// WEBPACK FOOTER //
// src/components/transaction/index.vue